import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import sanitize from 'sanitize'
import {
  getTermsFromPost,
  getImageFromPost,
  getAuthorFromPost,
} from '../../wpapi'

class BlogExcerpt extends React.Component {
  elem = React.createRef()
  imageElement = React.createRef()

  static propTypes = {
    featured: PropTypes.bool,
    post: PropTypes.shape({
      date: PropTypes.string,
      featured_media: PropTypes.string,
      categories: PropTypes.array,
      author: PropTypes.string,
      slug: PropTypes.string,
      title: PropTypes.shape({
        rendered: PropTypes.string,
      }),
    }),
  }

  render = () => {
    const { category } = getTermsFromPost(this.props.post)
    const image = getImageFromPost(this.props.post)
    const author = getAuthorFromPost(this.props.post)
    const date = new Date(this.props.post.date).toDateString()
    const size = this.props.featured ? 'full' : 'large'

    return (
      <div className="c-excerpt" ref={this.elem}>
        <div className="c-excerpt__image-area">
          {image && image.media_details.sizes[size] && (
            <img
              src={image.media_details.sizes[size].source_url}
              width={image.media_details.sizes[size].width}
              height={image.media_details.sizes[size].height}
              alt={image.alt_text}
              className={'c-excerpt__image'}
              ref={this.imageElement}
            />
          )}
        </div>
        <div className="c-excerpt__overlay" />
        <div className="c-excerpt__overlay-hover" />

        {category.name && author && (
          <div>
            <span className="c-excerpt__category">{category.name}</span>
            <h2 className="c-excerpt__heading">
              <span
                dangerouslySetInnerHTML={{
                  __html: sanitize(this.props.post.title.rendered, {}),
                }}
              />
              <span className="c-excerpt__heading-extra">
                {date} by{' '}
                <a
                  className="c-excerpt__heading-extra-link"
                  href={'/blog/author/' + author.slug}
                >
                  {author.name}
                </a>
              </span>
            </h2>
          </div>
        )}
        <Link className="c-excerpt__link" to={'/blog/' + this.props.post.slug}>
          <span className="visually-hidden">
            Continue reading ”{this.props.post.title.rendered}”
          </span>
        </Link>
      </div>
    )
  }
}

export default BlogExcerpt
